import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const BMIPage = lazy(() => import("./BMIPage"));

const BMIPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <BMIPage />
    </Suspense>
  );
};

export default BMIPageLazy;
